import {
  SlackIcon,
  JiraIcon,
  ConfluenceIcon,
} from '../../assets/icons/CustomIcons';

// Custom icon map keys referenced by catalog entity links (`icon: slack`, ...).
export const icons = {
  slack: SlackIcon,
  jira: JiraIcon,
  confluence: ConfluenceIcon,
};
